export default __webpack_public_path__ + "static/media/S-018.9c408481.png";